let Sortable = require('../mixins/sortable');
let Http     = require('../mixins/http');

module.exports = {
	mixins: [Sortable, Http],

	props: [
		'endpoint'
	],

	data() {
		return {
			isShowing: false,
			favorites: [],
		}
	},

	mounted() {
		this.$root.$on('toggle-favorites', this.toggleFavorites);
		this.$root.$on('activated', this.addItem);
		this.$root.$on('deactivated', this.removeItem);
	},

	created(){
		if(this.endpoint) {
			this.getFavorites();
		}
	},

	methods: {
		toggleFavorites() {
			this.isShowing = !this.isShowing;
		},

		getFavorites() {
			this.sendRequest(this.endpoint, 'get', this.updateList);
		},

		updateList(data){
			if(data.current_page) {
				this.favorites = data.data;
				this.pagination = data;
			} else {
				this.favorites = data;
			}

		},

		addItem(item) {
			item.liked_at = moment();

			this.favorites.unshift(item);
		},

		removeItem(item) {
			this.favorites = _.remove(this.favorites, function(favorite) {
				return favorite.id !== item.id;
			});
		}
	}
}
